import axios from 'axios';
import { REACT_APP_API } from '../../config';

export async function getYearlyPercentageRate({search}){
    if(!search.includes('-year,month')){
        if(search.includes('-year')){
            search = search.replace('-year', 'year')
        }else if(search.includes('year')){
            search = search.replace('year', '-year')
        }
    }
    try{
        return await axios.get(`${REACT_APP_API}/abms/percentageRates${search}`).then(result=>result.data);
    }catch(error){
        throw new Error(error)
    }
}
